module.exports = __webpack_public_path__ + "lp/img/scaling_icon_light.aebe63d4.svg";